// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cwc-root {
    position: relative;
    width: 100%;
    margin-top: 1rem;
    height: 2rem;
}

.cwc-bar {
    position: absolute;
    top: 0;
    height: 100%;
}

/* Full video duration bar */
.cwc-video-bar {
    width: 100%;
    background: #e0e0e0;
    cursor: pointer;
}

.cwc-video-bar-inner {
    position: relative;
    height: 100%;
    width: 100%;
}

.cwc-video-bar-select {
    position: absolute;
    border: dashed 3px #32621c;
    background-color: #32621c33;
    height: 100%;
    transition: opacity 0.3s ease;
    opacity: 0;
    z-index: 1;
}

    .cwc-video-bar-select.visible {
        opacity: 1;
    }

/* Viewport window bar */
.cwc-viewport-bar {
    background: #32621c88;
    border: solid 0.2rem #32621c;
    border-radius: 6px;
    pointer-events: none;
}

/* Clip interval bar */
.cwc-clip-bar {
    background: #60a9ef88;
    border: solid 0.2rem #60a9ef;
    top: 0.2rem;
    height: 1.6rem;
    border-radius: 6px;
    pointer-events: none;
    left: var(--clipLeft);
    width: var(--clipWidth);
}

.cwc-video-bar-select-timestamp {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-self: start;
    transform: translate(-50%,calc(-100%));
    width: fit-content;
    pointer-events: none;
    background-color: #32621c80;
}

    .cwc-video-bar-select-timestamp > .cwc-indicator {
        border-right: solid 2px white;
        height: 1.5rem;
        margin-bottom: 0.5rem;
        width: 50%;
    }
`, "",{"version":3,"sources":["webpack://./src/ClipMaker/css/ClipWindowContext.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,2BAA2B;IAC3B,YAAY;IACZ,6BAA6B;IAC7B,UAAU;IACV,UAAU;AACd;;IAEI;QACI,UAAU;IACd;;AAEJ,wBAAwB;AACxB;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,sBAAsB;AACtB;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,oBAAoB;IACpB,2BAA2B;AAC/B;;IAEI;QACI,6BAA6B;QAC7B,cAAc;QACd,qBAAqB;QACrB,UAAU;IACd","sourcesContent":[".cwc-root {\r\n    position: relative;\r\n    width: 100%;\r\n    margin-top: 1rem;\r\n    height: 2rem;\r\n}\r\n\r\n.cwc-bar {\r\n    position: absolute;\r\n    top: 0;\r\n    height: 100%;\r\n}\r\n\r\n/* Full video duration bar */\r\n.cwc-video-bar {\r\n    width: 100%;\r\n    background: #e0e0e0;\r\n    cursor: pointer;\r\n}\r\n\r\n.cwc-video-bar-inner {\r\n    position: relative;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.cwc-video-bar-select {\r\n    position: absolute;\r\n    border: dashed 3px #32621c;\r\n    background-color: #32621c33;\r\n    height: 100%;\r\n    transition: opacity 0.3s ease;\r\n    opacity: 0;\r\n    z-index: 1;\r\n}\r\n\r\n    .cwc-video-bar-select.visible {\r\n        opacity: 1;\r\n    }\r\n\r\n/* Viewport window bar */\r\n.cwc-viewport-bar {\r\n    background: #32621c88;\r\n    border: solid 0.2rem #32621c;\r\n    border-radius: 6px;\r\n    pointer-events: none;\r\n}\r\n\r\n/* Clip interval bar */\r\n.cwc-clip-bar {\r\n    background: #60a9ef88;\r\n    border: solid 0.2rem #60a9ef;\r\n    top: 0.2rem;\r\n    height: 1.6rem;\r\n    border-radius: 6px;\r\n    pointer-events: none;\r\n    left: var(--clipLeft);\r\n    width: var(--clipWidth);\r\n}\r\n\r\n.cwc-video-bar-select-timestamp {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-self: start;\r\n    transform: translate(-50%,calc(-100%));\r\n    width: fit-content;\r\n    pointer-events: none;\r\n    background-color: #32621c80;\r\n}\r\n\r\n    .cwc-video-bar-select-timestamp > .cwc-indicator {\r\n        border-right: solid 2px white;\r\n        height: 1.5rem;\r\n        margin-bottom: 0.5rem;\r\n        width: 50%;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
